<template>
<div>
    <h1 class="pt-2 text-sm">
        <h3 class="font-light">{{$t('form.iad.intervention_a_domicile')}}</h3>
    </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <div class="items-center md:flex">
            <img class="w-full mb-3 md:w-auto md:h-32" src="https://disticloudfiles.net/img/savinfo/default/iad.webp" alt="">
            <div class="ml-3">
                <div class="text-2xl font-semibold">
                    <div v-if="data && data.texte" v-html="$tt(data.texte)"></div>
                    <div v-if="data && !data.texte">{{$t('form.iad.intervention_a_domicile')}}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'iad',
    extends: FormCardExtension,

    methods: {
        end() {
            if (this.data.rdv) {
                this.nextBlock = this.$formTool.blockData(this.$options.name).next.rdv
            } else {
                this.nextBlock = this.$formTool.blockData(this.$options.name).next.end
            }
            this.emitChange()
        }
    },

    async mounted() {
        this.data = JSON.parse(this.$formTool.getFormData('set-case'))
        this.data.texte = await apiService.text('title_iad', this.$formTool.getFormData('proc').id, this.data.id_case)

        this.end()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/procedure/IadCard.vue